import { env } from '@/constant/process';
import { getDictionary } from '@/lib/i18n/dictionaries';

export async function getText() {
  return await getDictionary(env.publicLocale);
}

export const getIntlText = (key: string, values?: Record<string, string>) => {
  if (!values) return key;

  return key.replace(/{{\s*(\w+)\s*}}/g, (_, variableName) => {
    return values[variableName] || '';
  });
};
